// extracted by mini-css-extract-plugin
module.exports = {"app":"TimeoutWarning_app__6Ulpz","app_main":"TimeoutWarning_app_main__Wl9d0"};